module.exports = __webpack_public_path__ + "static/feature5-9d8db4dd8a35127bc187ab507ceba41e.png";